import { useProductFruitsApi } from "react-product-fruits";

import { INJECTION_DELAY_MS, ONBOARDING_CHECKLIST_ID } from "../constants";
import { ProductFruitsApi } from "../types";

import { ProductFruitsUserInfo } from "types/entities/ProductFruits";

const noop = (): void => {
  // No operation performed
};

export const useChecklistInjection = (
  checklistContentRef: React.RefObject<HTMLDivElement>,
  productFruitsRef: React.RefObject<HTMLDivElement>,
  productFruitsUserInfoData?: ProductFruitsUserInfo,
): void => {
  const clearExistingInjectedElements = (): void => {
    const checklistElement = checklistContentRef.current;

    if (checklistElement) {
      checklistElement.innerHTML = "";
    }
  };

  useProductFruitsApi(
    (api: ProductFruitsApi): (() => void) => {
      if (!productFruitsUserInfoData) return noop;

      const checklistElement = checklistContentRef.current;

      const timer = setTimeout(() => {
        clearExistingInjectedElements();

        if (checklistElement && productFruitsRef.current) {
          api.checklists.injectToElement(ONBOARDING_CHECKLIST_ID, checklistElement, {
            expand: true,
          });
        }
      }, INJECTION_DELAY_MS);

      return () => clearTimeout(timer);
    },
    [productFruitsUserInfoData, checklistContentRef, productFruitsRef],
  );
};
